<template>
    <div class="box">
        <div class="box-header">جستجو در نتایج:</div>
        <div class="box-content active filter-content">
            <div class="box-search ui-input ui-input--quick-search">
                <input v-model="searchInResult" type="text" class="ui-input-field ui-input-field--cleanable" placeholder="نام کالا، و یا برچسب  …">
                <span class="ui-input-cleaner"></span>
                <i @click="searchInResultOpration" class="iconsearch now-ui-icons ui-1_zoom-bold"></i>
                <i @click="searchInResultRemove" v-if="showRemoveIconInSearchInResult" class="iconremove now-ui-icons ui-1_simple-remove"></i>
            </div>
        </div>
    </div>
</template>

<script>
    import { filterEventBus } from "../../eventBus/eventBus";
    export default {
        data() {
            return {
                showRemoveIconInSearchInResult: false,
                searchInResult : '' 
            }
        }, 
        watch: {
            searchInResult: function (newValue, oldValue) {
                if (IsNullOrEmptyString(newValue)) {
                    this.showRemoveIconInSearchInResult = false;
                } else {
                    this.showRemoveIconInSearchInResult = true;
                }
            }
        },
        methods: {
            searchInResultOpration() {
                this.$parent.$data.searchInResult = this.searchInResult;
                filterEventBus.$emit('createQueryStringParameter');
            },
            searchInResultRemove() {
                this.searchInResult = '';
                this.searchInResultOpration();
            },
            initializSearchInResult(value) {
                this.searchInResult = value;
            }
        },
        created() {
            filterEventBus.$on('initializSearchInResult', (value) => { this.initializSearchInResult(value) })
        },
        beforeDestroy() {
            filterEventBus.$off('initializSearchInResult');
        }
    }
</script>

<style scoped>
    .box-search .iconremove {
        position: absolute;
        left: 45px;
        top: 10px;
        font-size: 20px;
        color: #555;
    }

    .box-search .iconsearch {
        position: absolute;
        left: 10px;
        top: 10px;
        font-size: 20px;
        color: #555;
    }

        .box-search .iconsearch:hover, .box-search .iconremove:hover {
            color: #222;
            cursor: pointer;
        }

        .box-search .iconsearch:after {
            content: '';
            height: 100%;
            width: 100%;
            border-right: 1px solid #999;
            padding-right: 7px;
        }
    .ui-input--quick-search .ui-input-field {
        padding-right: 17px;
    }
    .ui-input--quick-search::before {
        content: "";
    }
    .filter-content ul li:hover .filter-content ul li span {
        color: #000;
    }
</style>